import { render, staticRenderFns } from "./bord-cote.vue?vue&type=template&id=df553454&scoped=true"
import script from "./bord-cote.vue?vue&type=script&lang=js"
export * from "./bord-cote.vue?vue&type=script&lang=js"
import style0 from "./bord-cote.vue?vue&type=style&index=0&id=df553454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df553454",
  null
  
)

export default component.exports